"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialState = void 0;
const luxon_1 = require("luxon");
exports.InitialState = {
    timezone: luxon_1.IANAZone.create(new luxon_1.SystemZone().name),
};
